import { createReducer, on } from '@ngrx/store';
import { initialUiState, UiState } from './ui.state';
import { startLoadingAction, stopLoadingAction } from './ui.actions';

export const uiReducer = createReducer(
  initialUiState,
  on(startLoadingAction, (): UiState => {
    return { loading: true };
  }),
  on(stopLoadingAction, (): UiState => {
    return { loading: false };
  })
);
